<script setup>
/**
 * FormControlEmailMessageEventDate
 * A logic-only control that ensures the 'eventDate' field is
 * hidden from the UI by default.
 */
import { onMounted } from 'vue';

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number, Date],
        default: null
    }
});

// --- Lifecycle ---

onMounted(() => {
    /**
     * This field is typically handled by the FormControlEmailMessageEvent
     * table or used for internal logic, so we hide it from the standard
     * form input list.
     */
    props.field.hidden = true;
});
</script>